import React from 'react';
import '../assets/styles/tab.scss';

const Tab = (props) => <div className="tab">{props.children}</div>;

export { Tab };
